// Imports the AllRoutes component, which likely contains the routing logic for the app.
import { AllRoutes } from "./routes/AllRoutes";
// Imports the Header and Footer components from the components folder, for use in the layout.
import { Header, Footer } from "./components";
// Imports the main CSS file for the app, applying global styles.
import './App.css';

// Defines the main App component as a functional component.
function App() {
  return (
    // Returns JSX for rendering the application's structure.
    <div className="App">
      {/* Renders the Header component at the top of the app. */}
      <Header />
      {/* Renders the AllRoutes component, which includes the app's routing configuration. */}
      <AllRoutes />
      {/* Renders the Footer component at the bottom of the app. */}
      <Footer />
    </div>
  );
}

// Exports the App component as the default export of this module, making it available for use in other parts of the application.
export default App;
